

export const FLEXTIME_STATUS = {
    ACCEPTED: 'flextime_accepted',
    DECLINED: 'flextime_denied',
    PENDING: 'flextime_pending'
}

export const FLEXTIME_TYPE = {
    WEEKLY: 'weekly',
    MONTHLY: 'monthly'
}

export default {
    FLEXTIME_STATUS,
    FLEXTIME_TYPE
}